/**
 * Calculates the relative luminance of a hex color.
 * Returns a value between 0 (dark) and 1 (light).
 * Handles both 3-digit and 6-digit hex codes.
 */
const calculateLuminance = (hex: string): number => {
  hex = hex.replace('#', '');

  const expandedHex =
    hex.length === 3
      ? hex
          .split('')
          .map((char) => char + char)
          .join('')
      : hex;

  const r = parseInt(expandedHex.substring(0, 2), 16);
  const g = parseInt(expandedHex.substring(2, 4), 16);
  const b = parseInt(expandedHex.substring(4, 6), 16);

  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
};

/**
 * Determines if a color is light or dark based on its luminance.
 * Returns true for light colors, false for dark colors.
 */
const isLightColor = (hex: string): boolean => {
  return calculateLuminance(hex) > 0.5;
};

/**
 * Determines if a color is white or very close to white.
 * Uses a high luminance threshold (0.95) to catch off-white colors.
 */
const isWhiteColor = (hex: string): boolean => {
  return calculateLuminance(hex) > 0.95;
};

export { isLightColor, isWhiteColor };
